import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThankYouComponent } from './thank-you.component';
import { TranslateModule } from '@xref/ngx';

@NgModule({
    declarations: [ThankYouComponent],
    imports: [
        CommonModule,
        TranslateModule
    ],
    exports: [
        ThankYouComponent
    ]
})
export class ThankYouModule { }
